<template>
<div>
    <form id="contact-business" class="contact-form" action="/api/contact-form" method="POST" @submit.prevent="submit" novalidate>
        <div class="input-section col-2">
            <form-input-type-text
                name="name"
                :label="__('First name')"
                :errors="errors.name"
                required
                full-border
            ></form-input-type-text>
            <form-input-type-text name="surname" :label="__('Last name')" full-border></form-input-type-text>
        </div>

        <form-input-type-email
            name="email"
            :label="__('E-mail')"
            :errors="errors.email"
            required
            full-border
        ></form-input-type-email>

        <form-input-type-text
            name="phone"
            :label="__('Phone')"
            full-border
        ></form-input-type-text>

        <form-input-type-text name="company" :label="__('Company')" full-border></form-input-type-text>

        <form-input-type-text-area
            name="text"
            :label="__('Message')"
            :errors="errors.text"
            required
            full-border
        ></form-input-type-text-area>


        <p class="form-mandatory-fields">{{ __('* Fields marked with an asterisk (*) are mandatory.') }}</p>

        <div class="input-section">
            <div class="form-footer">
                <p
                    class="terms new-text-md"
                    v-html="__(`By entering your name and email you agree to our <a href='/privacy-policy' target='_blank'>Privacy Policy.</a>`)"
                ></p>
                <div class="form-send">
                    <v-button v-if="!this.en" :label="__('Send')" size="lg" type="submit" full-width></v-button>
                    <v-button v-else color="green" label="Get in touch" size="lg" type="submit" full-width></v-button>
                </div>
            </div>
        </div>
    </form>

    <flash-alert v-if="showAlert" @closeAlert="close" position="top" :text="__('Thank you for your message. Someone from our team will get back to you soon! Have a nice day.')"></flash-alert>
    <flash-alert v-if="failed" level="danger" @closeAlert="close" position="top" :text="__('Failed to send. Please try again.')"></flash-alert>
</div>
</template>

<script>
    import localforage from 'localforage'
    
    export default {
        props: {
            phoneCountry: {
                type: String,
                required: true,
                default: 'CS'
            },

            // TODO: k cemu pouzivame tohle?
            valueRefresh: {
                type: String,
                required: true
            }, 

            en: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                errors: {},
                showAlert: false
            }
        },
        mounted() {
            $('.item-contact').addClass('active')

            var that = this

            localforage.getItem('contact-successfully-send', function (err, value) {
                if(value) {
                    that.showAlert = true

                    localforage.removeItem('contact-successfully-send')
                }
            });
        },
        computed: {
            failed() {
                if(this.errors && this.errors['g-recaptcha-response']) {
                    return true
                } else {
                    return false
                }
            }
        },
        methods: {
            submit() {
                var that = this
                
                let formData = {
                    form_type: 'business'
                }

                grecaptcha.ready(function() {
                    grecaptcha.execute('6Ld1xdAcAAAAADk0PETFBUMbW366obkv65EmHObU', {action: 'submit'}).then(function(token) {
                        // serialize form data
                        $('#contact-business')
                            .serializeArray()
                            .forEach(({ name, value }) => {
                                formData[name] = value
                            })

                        formData['g-recaptcha-response'] = token

                        axios
                            .post('api/contact-form', formData, {
                                headers: {
                                    'Accept-Language': that.phoneCountry
                                }
                            })
                            .then((e) => {
                                localforage.setItem('contact-successfully-send', true)
                                location.reload()
                            })
                            .catch((e) => {
                                console.log(e.response)
                                that.errors = e.response.data.errors
                                Vuemit.fire('Button--sending-failed', true)
                                this.scrollToError()
                            })
                    })
                })
            },

            close() {
                this.showAlert = false
            },

            async scrollToError() {
                await this.$nextTick()

                var firstError = document.querySelector('.input-error-border')

                $('html, body').animate(
                    {
                        scrollTop: $(firstError).offset().top - 180
                    },
                    800
                )
            }
        }
    }
</script>
